// ReportDataForCompletedPigRunRequest.
//
// Class representing a report data request for a completed pig run.
export class ReportDataForCompletedPigRunRequest {
  public descending: boolean;
  public includeVerifiedPassagesOnly: boolean;
  public page: number;
  public rowsPerPage: number;
  public pigRunId: number;
  public sortBy: string;

  public constructor(pigRunId: number) {
    this.pigRunId = pigRunId;
    this.includeVerifiedPassagesOnly = false;
    this.page = -1;
    this.rowsPerPage = -1;
    this.sortBy = '';
    this.descending = false;
  }
}
